<template>
  <el-dialog
    title="分类管理"
    :visible.sync="dialogVisiClass"
    width="50%"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div
      style="min-height:30vh;max-height: 70vh;overflow-y: auto;"
      v-loading="loading"
    >
      <!-- @click="closeEdit()" -->
      <div class="operate_row">
        <el-input
          size="mini"
          type="text"
          maxlength="6"
          show-word-limit
          v-model="newOneClass"
          clearable
        >
        </el-input>
        <el-button type="primary" size="mini" @click.stop="addOneClassEvent()"
          >+ 新增一级分类</el-button
        >
      </div>

      <div
        class="tree_container"
        @drop="dropOne($event)"
        @dragover="dragoverOne($event)"
        @dragleave="dragleaveOne($event)"
      >
        <div
          class="tree_main curser_move"
          v-for="(item, index) in treeData"
          :key="item.oneClassId"
          @dragover="dragoverInOne($event, index)"
          :draggable="true"
          @dragstart="dragstartOne(item, index, $event)"
          @dragend="dragendOne(item, $event, item, 'one')"
        >
          <div class="one_class_row  curser_default">
            <i class="el-icon-s-operation"></i>
            <el-input
              v-if="index == openEditOne"
              :placeholder="item.oneClassName"
              size="mini"
              type="text"
              maxlength="6"
              show-word-limit
              v-model="editOneVal"
              clearable
              @blur.stop="editOneEvent(item, index)"
            >
            </el-input>
            <span v-else>
              {{ item.oneClassName }}
            </span>
            <i class="el-icon-edit" @click.stop="editOneBtn(index)"></i>
            <i
              class="el-icon-delete"
              @click.stop="deleteClass('one', item)"
            ></i>
          </div>
          <div
            class="two_class_box"
            @drop="drop($event)"
            @dragover="dragover($event)"
            @dragleave="dragleave($event)"
          >
            <div
              class="two_class_main"
              v-for="(val, valIndex) in handleTwoData(
                item.scriptTwoClassDtoList,
                index
              )"
              :key="val.classId"
            >
              <div
                v-if="val.classId == 'addTwo'"
                class="two_class_row add no_drag"
              >
                <!-- {{ val.name }} {{ openAddTwo }} -->
                <el-input
                  v-if="val.name == openAddTwo"
                  size="mini"
                  type="text"
                  maxlength="6"
                  show-word-limit
                  v-model="addTwoVal"
                  clearable
                  @blur.stop="addTwoEvent(item, index)"
                >
                </el-input>
                <el-button
                  v-else
                  type="primary"
                  size="mini"
                  @click.stop="addTwoBtn(index)"
                  >+ 新增二级分类</el-button
                >
              </div>
              <div
                v-else
                class="two_class_row"
                @dragover="dragoverIn($event, valIndex)"
                :draggable="true"
                @dragstart="dragstart(val, valIndex, $event)"
                @dragend="dragend(val, $event, item)"
              >
                <el-input
                  v-if="val.classId == openEditTwoId"
                  :placeholder="val.className"
                  size="mini"
                  type="text"
                  maxlength="6"
                  show-word-limit
                  v-model="editTwoVal"
                  clearable
                  @blur.stop="editTwoEvent(val, valIndex)"
                >
                </el-input>
                <span v-else class="curser_move">
                  {{ val.className }}
                </span>
                <i
                  class="el-icon-edit curser_default"
                  @click.stop="editTwoBtn(val.classId)"
                ></i>
                <i
                  class="el-icon-delete curser_default"
                  @click.stop="deleteClass('two', val)"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button type="primary" size="small" @click="handleClose">确定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
import {
  addOneClass,
  getTree,
  deleteOneClass,
  editOneClass,
  editTwoClass,
  addTwoClass,
  dragOneClass,
  dragtwoClass,
} from "@/api/sciptLibrary/index";

export default {
  props: {
    dialogVisiClass: {
      type: Boolean,
      default: false,
    },
    popupConfig: {
      type: Object,
      default: () => {
        return {
          title: "",
          scriptId: "",
        };
      },
    },
  },
  data() {
    return {
      loading: false,
      newOneClass: "",
      treeData: [],
      openEditOne: -1,
      openAddTwo: -1,
      editOneVal: "",
      addTwoVal: "",
      openEditTwoId: -1,
      editTwoVal: "",
      inDragArea: false,
      inDragAreaOne: false,
      IndexDragged: -1,
      IndexDraggedOne: -1,
      dataIndex: 0,
      dataIndexOne: 0,
      draging: null,
      dragingOne: null,
      animated: false,
    };
  },
  mounted() {
    this.getTree();
  },
  methods: {
    // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragoverOne(event) {
      event.preventDefault();
      var target = event.target;

      console.log(888888, this.animated);
      //因为dragover会发生在ul上，所以要判断是不是li
      // if (target.nodeName === "DIV" && target !== this.draging&& !this.animated) {
      //   console.log('dragover', event, target, target.nodeName);
      //   if (this.getIndexOne(this.draging) < this.getIndexOne(target)) {
      //       target.parentNode.insertBefore(this.draging, target.nextSibling);
      //   } else {
      //     // setTimeout(() => {
      //       target.parentNode.insertBefore(this.draging, target);
      //     // }, 300);
      //   }
      //   this.animated = true;
      //   setTimeout(() => {
      //     this.animated=false
      //   }, 400);
      // }
    },

    getIndexOne(el) {
      var index = 0;

      if (!el || !el.parentNode) {
        return -1;
      }

      while (el && (el = el.previousElementSibling)) {
        //console.log(el);
        index++;
      }

      return index;
    },

    // 离开放置区
    dragleaveOne(value) {
      console.log("dragleave111", value);
      value.preventDefault();
      this.inDragAreaOne = false;
    },
    // 进去放置区
    dropOne(value) {
      console.log("dragleave2222222", value);
      value.preventDefault();
      this.inDragAreaOne = true;
    },

    // 拖动事件（主要是为了拖动时鼠标光标不变为禁止）
    dragover(event) {
      event.preventDefault();

      var target = event.target;
      // //因为dragover会发生在ul上，所以要判断是不是li
      // if (target.nodeName === "DIV" && target !== this.draging) {
      //   console.log('dragover', event, target, target.nodeName);
      //   if (this.getIndex(this.draging) < this.getIndex(target)) {
      //       target.parentNode.insertBefore(this.draging, target.nextSibling);
      //   } else {
      //     // setTimeout(() => {
      //       target.parentNode.insertBefore(this.draging, target);
      //     // }, 300);
      //   }
      //   target.animated = false;
      //   setTimeout(() => {
      //     target.animated=true
      //   }, 300);
      // }
    },

    getIndex(el) {
      var index = 0;

      if (!el || !el.parentNode) {
        return -1;
      }

      while (el && (el = el.previousElementSibling)) {
        //console.log(el);
        index++;
      }

      return index;
    },
    // 离开放置区
    dragleave(value) {
      console.log("dragleave111", value);
      value.preventDefault();
      this.inDragArea = false;
    },
    // 进去放置区
    drop(value) {
      console.log("dragleave2222222", value);
      value.preventDefault();
      this.inDragArea = true;
    },

    // 内部多传一个index参数  即 非零就是内部拖拽
    dragstart(value, index, event) {
      console.log("dragstart", value, index);
      this.inDragArea = false;
      this.IndexDragged = index;
      this.draging = event.target;
    },
    // 内部多传一个index参数  即 非零就是内部拖拽
    dragstartOne(value, index, event) {
      console.log("dragstart", value, index);
      this.inDragAreaOne = false;
      this.IndexDraggedOne = index;
      this.dragingOne = event.target;
    },

    // 内部
    dragoverIn(e, i) {
      console.log("dragoverIn", e, i);
      // return
      const boxClient = e.currentTarget.getBoundingClientRect();
      // 插入数据盒子中心位置
      const centerY = boxClient.top + boxClient.height / 2;
      console.log(
        "计算插入位置",
        e,
        "被拖动的位置=" + this.IndexDragged,
        "要插入的位置=" + i,
        "插入数据盒子中心位置=" + centerY,
        "鼠标位置=" + e.clientY,
        Number(centerY) > Number(e.clientY)
      );

      if (centerY && e.clientY) {
        // 注意区分 预览区内部拖拽 先删除原来再插入新位置

        if (this.IndexDragged != undefined && this.IndexDragged <= i) {
          // 从上往下拖
          Number(centerY) > Number(e.clientY)
            ? this.dataIndex == 0 && i == 1
              ? (this.dataIndex = 0)
              : (this.dataIndex = i - 1)
            : (this.dataIndex = i);
        } else {
          Number(centerY) > Number(e.clientY)
            ? (this.dataIndex = i)
            : (this.dataIndex = i + 1);
        }
      }
    },
    dragoverInOne(e, i) {
      console.log("dragoverIn", e, i);
      // return
      const boxClient = e.currentTarget.getBoundingClientRect();
      // 插入数据盒子中心位置
      const centerY = boxClient.top + boxClient.height / 2;
      console.log(
        "计算插入位置",
        e,
        "被拖动的位置=" + this.IndexDraggedOne,
        "要插入的位置=" + i,
        "插入数据盒子中心位置=" + centerY,
        "鼠标位置=" + e.clientY,
        Number(centerY) > Number(e.clientY)
      );

      if (centerY && e.clientY) {
        // 注意区分 预览区内部拖拽 先删除原来再插入新位置
        if (this.IndexDraggedOne != undefined && this.IndexDraggedOne <= i) {
          // 从上往下拖
          Number(centerY) > Number(e.clientY)
            ? this.dataIndexOne == 0 && i == 1
              ? (this.dataIndexOne = 0)
              : (this.dataIndexOne = i - 1)
            : (this.dataIndexOne = i);
        } else {
          Number(centerY) > Number(e.clientY)
            ? (this.dataIndexOne = i)
            : (this.dataIndexOne = i + 1);
        }
      }
    },

    // 拖拽最终操作
    dragendOne(value, e, item, type) {
      e.preventDefault();

      // console.log(
      //   "拖拽最终",
      //   value, '被拖动分类:' + value.className,
      //   '被拖动分类id:' + value.classId,
      //   '被拖动分类父级（一级）id:' + value.oneClassId,
      //   '插入位置数据:', item.scriptTwoClassDtoList,
      //   e,
      //   "被拖动数据位置index=" + this.IndexDraggedOne,
      //   "插入数据位置index=" + this.dataIndexOne,
      //   "是否在释放区" + this.inDragAreaOne
      // );

      if (
        this.inDragAreaOne == true &&
        this.IndexDraggedOne != this.dataIndexOne
      ) {
        let afterClassIdOne = "";

        if (this.dataIndexOne == this.treeData.length - 1) {
          afterClassIdOne = null;
        } else if (this.dataIndexOne > this.IndexDraggedOne) {
          afterClassIdOne = this.treeData[this.dataIndexOne + 1].oneClassId;
        } else if (this.dataIndexOne < this.IndexDraggedOne) {
          afterClassIdOne = this.treeData[this.dataIndexOne].oneClassId;
        }
        console.log("fasong", {
          moveClassId: value.oneClassId,
          afterClassId: afterClassIdOne,
        });
        this.DragSortApiOne({
          moveClassId: value.oneClassId,
          afterClassId: afterClassIdOne,
        });
      }

      // console.log('数据', pageJson.value.seaData, pageJson.value.defaultData, pageJson.value.otherData, pageJson.value.navData, );
    },
    // 拖拽最终操作
    dragend(value, e, item, type) {
      e.preventDefault();

      // console.log(
      //   "拖拽最终",
      //   value, '被拖动分类:' + value.className,
      //   '被拖动分类id:' + value.classId,
      //   '被拖动分类父级（一级）id:' + value.oneClassId,
      //   '插入位置数据:', item.scriptTwoClassDtoList,
      //   e,
      //   "被拖动数据位置index=" + this.IndexDragged,
      //   "插入数据位置index=" + this.dataIndex,
      //   "是否在释放区" + this.inDragArea
      // );

      if (this.inDragArea == true && this.IndexDragged != this.dataIndex) {
        console.log(999, value, item.scriptTwoClassDtoList.length);

        let afterClassIdNew = "";
        if (this.dataIndex == item.scriptTwoClassDtoList.length - 1) {
          afterClassIdNew = null;
        } else if (this.dataIndex > this.IndexDragged) {
          afterClassIdNew =
            item.scriptTwoClassDtoList[this.dataIndex + 1].classId;
        } else if (this.dataIndex < this.IndexDragged) {
          afterClassIdNew = item.scriptTwoClassDtoList[this.dataIndex].classId;
        }

        console.log("fasong", {
          oneClassId: value.oneClassId,
          moveClassId: value.classId,
          afterClassId: afterClassIdNew,
        });
        this.DragSortApi({
          oneClassId: value.oneClassId,
          moveClassId: value.classId,
          afterClassId: afterClassIdNew,
        });
      }

      // console.log('数据', pageJson.value.seaData, pageJson.value.defaultData, pageJson.value.otherData, pageJson.value.navData, );
    },

    async DragSortApiOne(params) {
      this.loading = true;
      let res = await dragOneClass(params, true);
      console.log("DragSortApiOne", res);
      if (res.error.code == 200 && res.data.length > 0) {
        // this.treeData = res.data
        this.getTree();
      } else {
        this.treeData = [];
      }
      this.loading = false;
    },
    async DragSortApi(params) {
      this.loading = true;
      let res = await dragtwoClass(params, true);
      console.log("DragSortApi", res);
      if (res.error.code == 200 && res.data.length > 0) {
        // this.treeData = res.data
        this.getTree();
      } else {
        this.treeData = [];
      }
      this.loading = false;
    },

    async getTree() {
      this.loading = true;
      let res = await getTree(true);
      console.log(52, res);
      if (res.error.code == 200 && res.data.length > 0) {
        this.treeData = res.data;
      } else {
        this.treeData = [];
      }
      this.loading = false;

      // if (this.ruleForm.oneClassId) {
      //   this.getTwoClassData()
      // }
    },
    handleTwoData(data, index) {
      // 处理二级数据  增加一条新增

      const data1 = JSON.parse(JSON.stringify(data||[]));
      data1.push({
        classId: "addTwo",
        name: "addTwo" + index,
      });
      console.log(777, data1);
      return data1;
    },
    async addOneClassEvent() {
      if (!this.newOneClass) {
        return this.$message({
          type: "warning",
          message: "新增一级分类名不能为空",
        });
      } else {
        const res = await addOneClass({ className: this.newOneClass }, true);
        console.log("新增一级分类", res);
        if (res.error.code == 200) {
          this.$message({
            type: "success",
            message: "新增成功!",
          });
          this.getTree();
        } else {
          // this.$message({
          //   type: "error",
          //   message: res.error.message,
          // });
        }
      }
    },

    // async addTwoClass(item) {
    //   if (!this.newOneClass) {
    //     return this.$message({
    //       type: 'warning',
    //       message: '新增一级分类名不能为空'
    //     })
    //   }
    //   const res = await addTwoClass({ className: this.newOneClass, oneClassId: item.oneClassId }, true)
    //   console.log('新增一级分类', res);
    //   if (res.error.code == 200) {

    //     this.$message({
    //       type: 'success',
    //       message: '新增成功!'
    //     });
    //     this.getTree()
    //   } else {
    //     this.$message({
    //       type: 'error',
    //       message: res.error.message
    //     });
    //   }
    // },

    editOneBtn(index) {
      if (index == this.openEditOne) {
        this.openEditOne = -1;
      } else {
        this.openEditOne = index;
      }
    },
    editTwoBtn(id) {
      if (id == this.openEditTwoId) {
        this.openEditTwoId = -1;
      } else {
        this.openEditTwoId = id;
      }
    },

    addTwoBtn(index) {
      console.log(888, index);
      if ("addTwo" + index == this.openAddTwo) {
        this.openAddTwo = -1;
      } else {
        this.openAddTwo = "addTwo" + index;
      }
    },
    closeEdit() {
      console.log("closeEdit");
      this.openEditOne = -1;
      this.openAddTwo = -1;
    },

    async editOneEvent(item, index) {
      console.log(77, item, item.oneClassId, this.editOneVal);

      if (!this.editOneVal) {
        this.openEditOne = -1;
        return;
      }
      const res = await editOneClass(
        item.oneClassId,
        { className: this.editOneVal },
        true
      );
      console.log("editOneClass", res);
      if (res.error.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        // this.getTree()
        this.treeData[index].oneClassName = this.editOneVal;
        this.openEditOne = -1;
      } else {
        // this.$message({
        //   type: "error",
        //   message: res.error.message,
        // });
      }
    },
    async editTwoEvent(item, index) {
      console.log("editTwoEvent", item, item.oneClassId, this.editTwoVal);

      if (!this.editTwoVal) {
        this.openEditTwoId = -1;
        return;
      }

      this.loading = true;
      const res = await editTwoClass(
        item.classId,
        { className: this.editTwoVal, oneClassId: item.oneClassId },
        true
      );
      console.log("editTwoClass", res);

      this.loading = false;
      if (res.error.code == 200) {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.getTree();
        // this.treeData[index].oneClassName = this.editOneVal
        this.openEditTwoId = -1;
      } else {
        // this.$message({
        //   type: "error",
        //   message: res.error.message,
        // });
      }
    },

    async addTwoEvent(item, index) {
      console.log("addTwoEvent", item, index, this.addTwoVal);
      if (!this.addTwoVal) {
        this.openAddTwo = -1;
        return;
      }
      const res = await addTwoClass(
        { className: this.addTwoVal, oneClassId: item.oneClassId },
        true
      );
      console.log("addTwoClass", res);
      if (res.error.code == 200) {
        this.$message({
          type: "success",
          message: "新增成功!",
        });
        this.openAddTwo = -1;
        this.addTwoVal = "";

        setTimeout(() => {
          this.getTree();
        }, 100);
        // this.treeData[index].oneClassName = this.editOneVal
      } else {
        // this.$message({
        //   type: "error",
        //   message: res.error.message,
        // });
      }
    },

    deleteClass(type, item) {
      // 二级分类可直接删除，
      // 提示：【删除该分类后，对应话术也自动删除，请确认】
      // 一级分类在有二级分类存在时，不可直接删除，
      // 当没有二级分类时，可直接删除。

      console.log("deleteClass", type, item);

      if ((type == "one" && item.scriptTwoClassDtoList?.length > 0) || false) {
        return this.$message({
          type: "warning",
          message: "一级分类在有二级分类存在时，不可直接删除",
        });
      }
      let deleteId = "";
      let apiName = "";
      let tips = "";

      if (type == "one") {
        deleteId = item.oneClassId;
        apiName = "one_class";
        tips = "此操作将永久删除该分类, 是否继续?";
      } else {
        deleteId = item.classId;
        apiName = "two_class";
        tips = "删除该分类后，对应话术也自动删除，请确认";
      }
      console.log(111, tips);

      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api();
        })
        .catch(() => {});

      const api = async () => {
        console.log("queding", apiName, deleteId);

        this.loading = true;
        let res = await deleteOneClass(apiName, deleteId, true);

        console.log("deleteOneClass", res);
        if (res.error.code == 200) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.getTree();
        } else {
          // this.$message({
          //   type: "error",
          //   message: res.error.message,
          // });
        }
        this.loading = false;
      };
    },

    handleClose() {
      this.$emit("update:dialogVisiClass", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.operate_row {
  display: flex;

  .el-input {
    width: 220px;
    margin-right: 5px;
  }
}

$lineHeight: 30px; //文字行高
$padding: 10px 20px; //文字行边距
$spaceOneTwo: 30px; //一二级左右间隔间隔 $spaceOneTwo*2

.tree_main {
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  padding: 10px;
  &:hover {
    background-color: #f9f9f9;
  }

  i {
    margin-left: 10px;
  }

  .one_class_row {
    min-width: 50px;
    max-width: 220px;
    word-break: normal;
    margin-right: $spaceOneTwo;
    white-space: nowrap;
    line-height: $lineHeight;
    padding: $padding;
    position: relative;

    &::after {
      top: 50%;
      position: absolute;
      content: "";
      display: block;
      width: $spaceOneTwo;
      height: 1px;
      right: -$spaceOneTwo;
      border: 1px solid #ccc;
      border-style: solid none none none;
    }
  }

  .two_class_box {
    display: flex;
    flex-direction: column;
    // background-color: yellow;

    .two_class_main {
      // background-color: rgb(33, 160, 113);
      // padding-bottom: 80px;
      line-height: $lineHeight;
      padding: $padding;

      width: 50%;
      position: relative;
      border: 1px solid #ccc;
      border-style: none none none solid;

      &::before {
        display: block;
        content: "";
        position: absolute;
        background-color: #fff;
        width: 1px;
        height: 50%;
      }

      &:first-child::before {
        left: -1px;
        top: 0;
      }

      &:last-child::before {
        left: -1px;
        bottom: 0;
      }

      &::after {
        top: 50%;
        left: 0;
        position: absolute;
        content: "";
        display: block;
        width: $spaceOneTwo;
        height: 1px;
        border: 1px solid #ccc;
        border-style: solid none none none;
      }

      .two_class_row {
        // display: flex;
        // flex-wrap: nowrap;
        width: 100%;
        white-space: nowrap;
        margin-left: $spaceOneTwo;
        border-radius: 10px;
        padding: 0 10px;
        &:hover {
          background-color: #e4e4e4;
        }
      }

      &:last-child {
        .add {
          display: block;
        }
      }

      .add {
        display: none;
      }
    }
  }
}

.curser_move {
  // display: block;
  cursor: move;
}

.curser_default {
  // display: block;
  cursor: default;
}

// 禁止拖拽
.no_drag {
  -webkit-user-drag: none !important;
}
</style>
